module.exports = __webpack_public_path__ + "img/sparks-green-large.2d323d5e.png";